<div class="availability-container" data-cy="availability-grid">
  <!-- Compact schedule grid -->
  <div class="schedule-grid">
    <!-- Header row with days -->
    <div class="grid-header">
      <div class="period-cell"></div>
      <div
        class="day-cell"
        *ngFor="let day of weekDays; trackBy: trackByDayId"
        [attr.data-cy]="'day-' + day.code"
        [attr.aria-label]="day.full"
      >
        {{ day.short }}
      </div>
    </div>

    <!-- Period rows -->
    <div
      class="grid-row"
      *ngFor="let period of timePeriods; trackBy: trackByPeriodId"
      [attr.data-cy]="'period-' + period.code"
    >
      <div class="period-cell" [attr.aria-label]="period.name">
        <span class="period-name">{{
          period.code === "morning"
            ? "M"
            : period.code === "afternoon"
            ? "T"
            : "N"
        }}</span>
      </div>
      <div
        class="slot-cell"
        *ngFor="let day of weekDays; trackBy: trackByDayId"
        [class.selected]="isSlotSelected(day.id, period.id)"
        [class.disabled]="!editable"
        [attr.role]="editable ? 'button' : 'gridcell'"
        [attr.aria-pressed]="editable ? isSlotSelected(day.id, period.id) : null"
        [attr.aria-label]="getSlotAriaLabel(day.full, period.name, isSlotSelected(day.id, period.id))"
        [attr.tabindex]="editable ? '0' : '-1'"
        (click)="editable ? selectPlace(+(day.id + '' + period.id)) : null"
        (keydown.enter)="editable ? selectPlace(+(day.id + '' + period.id)) : null"
        (keydown.space)="editable ? selectPlace(+(day.id + '' + period.id)) : null"
        [attr.data-cy]="'slot-' + day.code + '-' + period.code"
        [matTooltip]="getSlotTooltip(day.short, period.name)"
        [style.cursor]="editable ? 'pointer' : 'default'"
      >
        <mat-icon 
          *ngIf="isSlotSelected(day.id, period.id)" 
          class="check-icon"
          [attr.aria-hidden]="true"
        >check</mat-icon>
      </div>
    </div>
  </div>

  <!-- Compact actions - só exibe no modo editável -->
  <div class="compact-actions" *ngIf="editable" role="toolbar" aria-label="Ações rápidas de disponibilidade">
    <button
      type="button"
      mat-icon-button
      (click)="selectAllWeekdays($event)"
      data-cy="weekdays-btn"
      matTooltip="Selecionar dias úteis (Segunda a Sexta)"
      color="primary"
      [attr.aria-label]="'Selecionar todos os dias úteis'"
    >
      <mat-icon>work</mat-icon>
    </button>

    <button
      type="button"
      mat-icon-button
      (click)="selectWeekend($event)"
      data-cy="weekend-btn"
      matTooltip="Selecionar fim de semana (Sábado e Domingo)"
      color="accent"
      [attr.aria-label]="'Selecionar fim de semana'"
    >
      <mat-icon>weekend</mat-icon>
    </button>

    <button
      type="button"
      mat-icon-button
      (click)="clearAll($event)"
      data-cy="clear-btn"
      matTooltip="Limpar todas as seleções"
      color="warn"
      [attr.aria-label]="'Limpar todas as seleções'"
    >
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
